<script setup lang="ts">
definePageMeta({
  name: 'journal-article-volume',
  key: (route) => {
    const p = route.params as { publisherId?: string, volume?: string, issue?: string, articleNumber?: string }
    return `journal-article-volume-${p.publisherId}-${p.volume}-${p.issue}-${p.articleNumber}`
  },
  layout: 'default-with-mobile-notice',
  theme: 'carbon',
  mobileReady: true,
})

const route = useRoute<'journal-article-volume'>()

const publisherId = computed(() => route.params.publisherId ?? '')
const volume = computed(() => route.params.volume ?? '')
const issue = computed(() => route.params.issue ?? '')
const articleNumber = computed(() => route.params.articleNumber ?? '')
</script>

<template>
  <JournalsArticlePage
    variant="volume"
    :publisher-id="publisherId"
    :volume="volume"
    :issue="issue"
    :article-number="articleNumber"
  />
</template>
